// Central content + asset registry for STERILTRON

export const IMG = {
  hero: "/assets/green/hero.jpg",
  solMedicalWaste: "/assets/green/sol-medical-waste.jpg",
  solSterilization: "/assets/green/sol-sterilization.jpg",
  solIntegrated: "/assets/green/sol-integrated.jpg",
  solIndustrial: "/assets/green/sol-industrial.jpg",
  solSteam: "/assets/green/sol-steam.jpg",
  prodIss: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/6a0222e99eafb8663afad7078fd55d3a0d4f83374a2f93fe406890a84de5400b.jpeg",
  prodLargeAutoclave: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/d341d3301ae3b54beed8d27c5657327b371869318f826ae6d63326ac8f2c0fa8.jpeg",
  prodMediumAutoclave: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/1c11582ff7d85213fc8816fe9b7f63bbeccd4c1b5fd859703a6283dcca304335.jpeg",
  prodSmallAutoclave: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/5872d78d1490b402a0b617536b23cd7b8a437f1929022d59b8f4879bdb17f971.jpeg",
  prodSteamGen: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/d87040e4cade3c72af762c902e0db7d8d6b19c58bd8586dbc6a7ec30a395aa30.jpeg",
  prodShredder: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/5244842d2cb16bb9fd9df538886438ff82efd27c72b1468a116eb3cd0771714b.jpeg",
  aboutFacility: "/assets/green/about-facility.jpg",
  engineeringTeam: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/590f5feecad99d39ddc1e4545c77235e723b3045348a830888dda21c4b97bdef.jpeg",
  sustainability: "/assets/green/sustainability.jpg",
  globalMap: "/assets/green/global-map.jpg",
  projectHospital: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/81ab8ccfaf5c6ff4b5ee366c2e7c1704976c23bc692627f0a8431b504c7df138.jpeg",
  projectWaste: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/aa6eab1fa8737df7f97a98c39700a2d7cf102fe4c809c96cac7a0730e0e9c5cd.jpeg",
  projectIndustrial: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/b605583b0bd5c7221a81d7ecfdef6c04bf61a04996a3ac034c18d9947207a6da.jpeg",
  ctaTexture: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/6617b276f62edc4fe83121489f06872d5ae5b6d506df2538e8a99fec961261f2.jpeg",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Products", to: "/products" },
  { label: "Solutions", to: "/solutions" },
  { label: "Projects", to: "/projects" },
  { label: "Blog", to: "/blog" },
  { label: "Videos", to: "/videos" },
  { label: "News", to: "/news" },
  { label: "Contact", to: "/contact" },
];

export const STATS = [
  { value: "40+", label: "Countries served" },
  { value: "300+", label: "Systems deployed" },
  { value: "25", label: "Years of engineering" },
  { value: "99.9%", label: "Sterilization efficacy" },
];

export const SOLUTIONS = [
  {
    slug: "medical-waste-treatment",
    title: "Medical Waste Treatment",
    image: IMG.solMedicalWaste,
    short: "On-site treatment of infectious and hazardous healthcare waste using validated steam sterilization.",
    body: "STERILTRON medical waste treatment systems neutralise the biological hazard of infectious clinical waste directly at the point of generation. By combining controlled thermal sterilization with mechanical volume reduction, facilities eliminate the need for external hauling of untreated material and gain full traceability over their waste stream.",
    features: [
      "Validated moist-heat sterilization to internationally recognised STAATT Level III standards",
      "Integrated shredding for irreversible volume and weight reduction",
      "Closed-loop process with no hazardous emissions",
      "Full digital cycle logging for regulatory audit trails",
    ],
  },
  {
    slug: "sterilization-systems",
    title: "Sterilization Systems",
    image: IMG.solSterilization,
    short: "Steam sterilizers and autoclaves engineered for hospitals, laboratories and clinics.",
    body: "Our sterilization portfolio spans compact tabletop units to large double-door hospital autoclaves. Every chamber is built from AISI 316L stainless steel and controlled by a programmable logic system that documents each phase of the cycle for complete assurance.",
    features: [
      "Pre-vacuum and gravity cycles for a broad range of load types",
      "AISI 316L chambers with precision-welded pressure vessels",
      "Touchscreen control with role-based access and cycle archiving",
      "Compliant with EN 285, EN 13060 and pressure-equipment directives",
    ],
  },
  {
    slug: "integrated-waste-processing",
    title: "Integrated Waste Processing",
    image: IMG.solIntegrated,
    short: "Single-chamber sterilize-and-shred technology for a compact, self-contained waste line.",
    body: "The integrated approach performs sterilization and shredding within one enclosure, transforming hazardous waste into an unrecognisable, decontaminated output in a single automated sequence. It is the smallest possible footprint for a complete on-site treatment line.",
    features: [
      "Sterilization and shredding in one continuous automated cycle",
      "Minimal footprint suited to constrained utility rooms",
      "Unrecognisable, decontaminated output ready for standard disposal",
      "Reduced operator handling and cross-contamination risk",
    ],
  },
  {
    slug: "industrial-solutions",
    title: "Industrial Solutions",
    image: IMG.solIndustrial,
    short: "Custom process lines for pharmaceutical, laboratory and industrial decontamination.",
    body: "Beyond healthcare, STERILTRON engineers bespoke industrial process systems for pharmaceutical manufacturing, research laboratories and effluent decontamination. Each line is dimensioned to the customer's throughput, utilities and validation requirements.",
    features: [
      "Made-to-measure capacity and layout engineering",
      "Effluent decontamination and biosafety containment lines",
      "Integration with existing SCADA and building management systems",
      "Documentation packages for IQ / OQ / PQ validation",
    ],
  },
  {
    slug: "steam-utility-systems",
    title: "Steam & Utility Systems",
    image: IMG.solSteam,
    short: "Clean steam generation and utility packages that power reliable sterilization.",
    body: "Reliable sterilization depends on a reliable steam supply. Our electric and fuel-fired steam generators, water treatment and utility skids are engineered to deliver consistent, clean steam quality that protects both the process and the equipment it serves.",
    features: [
      "Electric and fuel-fired clean-steam generators",
      "Feed-water treatment and conditioning packages",
      "Redundant configurations for continuous operation",
      "Energy-recovery options to reduce operating cost",
    ],
  },
];

export const SOLUTION_DETAILS = {
  "medical-waste-treatment": {
    tagline: "Neutralise infectious and hazardous healthcare waste at the point of generation.",
    overview: "STERILTRON medical waste treatment systems eliminate the biological hazard of infectious clinical waste directly on-site, removing the risk and cost of transporting untreated material. Validated moist-heat sterilization is combined with mechanical volume reduction to produce a decontaminated, unrecognisable output — with full digital traceability for every batch. The result is a treatment line that facilities own and control end to end.",
    process: [
      { title: "Load", text: "Sealed clinical waste bins are loaded into the treatment chamber with minimal operator handling." },
      { title: "Sterilize", text: "Saturated steam is applied at validated temperature and pressure to inactivate all microbial life to STAATT Level III." },
      { title: "Reduce", text: "The sterilized load is shredded and compacted, cutting volume by up to 80%." },
      { title: "Document", text: "A complete, tamper-evident cycle report is archived for regulatory audit." },
    ],
    specs: [
      ["Sterilization standard", "STAATT Level III"],
      ["Operating temperature", "up to 134 °C"],
      ["Volume reduction", "up to 80%"],
      ["Capacity range", "120 – 400 L / cycle"],
      ["Construction", "AISI 316L stainless steel"],
      ["Traceability", "Digital cycle logging + export"],
    ],
    caseExamples: [
      { title: "Regional hospital waste line", region: "Central Europe", sector: "900-bed hospital", result: "Eliminated external hauling of untreated waste and cut disposal volume by ~75%." },
      { title: "District healthcare network", region: "South-East Asia", sector: "Multi-site rollout", result: "Standardised on-site treatment across district hospitals with centralised reporting." },
    ],
    relatedProducts: ["sn330", "sd420"],
  },
  "sterilization-systems": {
    tagline: "Steam sterilizers and autoclaves for hospitals, laboratories and clinics.",
    overview: "From compact benchtop units to large double-door hospital autoclaves, STERILTRON sterilization systems deliver validated, repeatable results for every load type. Each chamber is built from AISI 316L stainless steel and governed by a programmable control system that documents every phase of the cycle — giving CSSD teams and laboratories complete assurance and a full audit trail.",
    process: [
      { title: "Air removal", text: "Fractionated pre-vacuum pulses evacuate air from the chamber and load for complete steam penetration." },
      { title: "Exposure", text: "Saturated steam holds the load at the validated temperature for the required sterilization time." },
      { title: "Dry", text: "A controlled post-vacuum drying phase leaves wrapped instruments ready for storage." },
      { title: "Verify", text: "Temperature, pressure and time are recorded throughout for EN 285 / EN 13060 compliance." },
    ],
    specs: [
      ["Standards", "EN 285 / EN 13060"],
      ["Operating temperature", "121 – 134 °C"],
      ["Chamber range", "18 – 900 L"],
      ["Cycle types", "Pre-vacuum / gravity / Class B"],
      ["Vessel material", "AISI 316L"],
      ["Control", "PLC with cycle archiving"],
    ],
    caseExamples: [
      { title: "University hospital CSSD upgrade", region: "Western Europe", sector: "Central Sterile Services", result: "Double-door barrier sterilizers with full traceability software integrated into the workflow." },
      { title: "Metropolitan clinic programme", region: "Northern Europe", sector: "Outpatient network", result: "Fleet of medium and benchtop sterilizers commissioned across urban clinics." },
    ],
    relatedProducts: ["sn250", "sd250", "pn110"],
  },
  "integrated-waste-processing": {
    tagline: "Sterilize-and-shred in a single enclosure for the smallest possible footprint.",
    overview: "The integrated approach performs sterilization and shredding within one automated sequence, transforming hazardous waste into a decontaminated, unrecognisable output in a single pass. It is the most compact way to establish a complete on-site treatment line — ideal for facilities where space and operator handling must both be minimised.",
    process: [
      { title: "Single load", text: "Waste is loaded once into a combined sterilization-and-shredding chamber." },
      { title: "Treat", text: "Saturated steam sterilizes the load to STAATT Level III without a separate transfer step." },
      { title: "Shred in place", text: "A torque-controlled shredder renders the sterilized waste unrecognisable within the same enclosure." },
      { title: "Discharge", text: "Decontaminated, volume-reduced output is discharged ready for standard disposal." },
    ],
    specs: [
      ["Process", "Sterilize + shred, one cycle"],
      ["Sterilization standard", "STAATT Level III"],
      ["Footprint", "Single-enclosure, compact"],
      ["Volume reduction", "up to 80%"],
      ["Operator handling", "Minimised, closed process"],
      ["Data", "Full cycle logging"],
    ],
    caseExamples: [
      { title: "National network deployment", region: "South-East Asia", sector: "District hospitals", result: "Standardised integrated units deployed for consistent, low-footprint treatment." },
      { title: "Constrained utility room retrofit", region: "Middle East", sector: "Private hospital", result: "Complete on-site line installed where a multi-machine layout was impossible." },
    ],
    relatedProducts: ["sn330", "sd420"],
  },
  "industrial-solutions": {
    tagline: "Custom process and decontamination lines for pharma, laboratory and industry.",
    overview: "Beyond healthcare, STERILTRON engineers bespoke industrial process systems for pharmaceutical manufacturing, research laboratories and effluent decontamination. Each line is dimensioned to the customer's throughput, utilities and validation requirements, and integrates with existing SCADA and building-management infrastructure — delivered with full IQ/OQ/PQ documentation.",
    process: [
      { title: "Assess", text: "We analyse throughput, utilities, containment level and regulatory requirements on-site." },
      { title: "Engineer", text: "A made-to-measure line is designed around your capacity, layout and validation needs." },
      { title: "Integrate", text: "The system connects to existing SCADA / BMS for unified monitoring and control." },
      { title: "Validate", text: "Commissioning is completed with a full IQ / OQ / PQ documentation package." },
    ],
    specs: [
      ["Design basis", "Made-to-measure capacity"],
      ["Containment", "Biosafety / effluent options"],
      ["Integration", "SCADA / BMS compatible"],
      ["Validation", "IQ / OQ / PQ documentation"],
      ["Materials", "Corrosion-resistant stainless"],
      ["Sectors", "Pharma / lab / industrial"],
    ],
    caseExamples: [
      { title: "Pharmaceutical decontamination line", region: "Middle East", sector: "Manufacturing plant", result: "Custom effluent and biosafety system integrated into an existing facility." },
      { title: "Research laboratory upgrade", region: "Europe", sector: "Life-sciences institute", result: "Bespoke decontamination line delivered with full validation documentation." },
    ],
    relatedProducts: ["sn330", "sd420"],
  },
  "steam-utility-systems": {
    tagline: "Clean steam generation and utility packages engineered for sterilization duty.",
    overview: "Reliable sterilization depends on a reliable steam supply. STERILTRON electric and fuel-fired steam generators, feed-water treatment and utility skids deliver consistent, high-purity steam sized precisely to the connected load. Redundant configurations and energy-recovery options keep critical processes running while reducing operating cost.",
    process: [
      { title: "Treat water", text: "Feed-water is conditioned to protect the generator and ensure clean steam quality." },
      { title: "Generate", text: "Electric or fuel-fired heating converts treated water into pure steam on demand." },
      { title: "Modulate", text: "Output modulates precisely to match fluctuating sterilization demand." },
      { title: "Protect", text: "Multi-level safety instrumentation and redundancy sustain continuous operation." },
    ],
    specs: [
      ["Output range", "50 – 500 kg/h"],
      ["Steam pressure", "up to 10 bar"],
      ["Heating", "Electric / fuel-fired"],
      ["Redundancy", "Twin-generator options"],
      ["Efficiency", "Heat-recovery available"],
      ["Mounting", "Skid-mounted, pre-piped"],
    ],
    caseExamples: [
      { title: "CSSD steam backbone", region: "Western Europe", sector: "Hospital", result: "Redundant clean-steam generators supplying a busy central sterile services department." },
      { title: "Pharmaceutical clean-steam duty", region: "Europe", sector: "Manufacturing", result: "Modulating generator package matched to variable process steam demand." },
    ],
    relatedProducts: ["sn330", "sd420"],
  },
};

// eslint-disable-next-line no-unused-vars
const _LEGACY_PRODUCTS = [
  {
    slug: "iss-integrated-sterilizer-shredder",
    name: "STERILTRON ISS Integrated Sterilizer & Shredder",
    category: "Steam Sterilizers",
    image: IMG.prodIss,
    tagline: "A complete on-site treatment line inside a single stainless-steel enclosure.",
    intro: "The ISS combines validated steam sterilization and heavy-duty shredding in one automated cycle, converting infectious healthcare waste into safe, unrecognisable and volume-reduced output without any external handling.",
    overview: "Engineered for demanding healthcare environments, the STERILTRON ISS unifies controlled sterilization and mechanical waste processing within one integrated solution. Waste is loaded, sterilized under saturated steam and shredded in the same chamber, removing the need to transport untreated infectious material off-site. The result is a compact, self-contained line that gives facilities full ownership of their waste stream and its documentation.",
    benefits: [
      "Eliminates transport of untreated infectious waste from your site",
      "Up to 80% volume reduction lowers downstream disposal cost",
      "Single automated cycle reduces operator exposure and handling",
      "Complete digital records for every treated batch",
    ],
    applications: [
      "Hospitals and district healthcare centres",
      "Clinical and diagnostic laboratories",
      "Dialysis and infectious-disease units",
      "Regional medical waste treatment hubs",
    ],
    technology: "The ISS applies saturated steam at validated temperature and pressure to achieve microbial inactivation to STAATT Level III, then engages a torque-controlled shredder to render the sterilized load unrecognisable. A programmable controller governs each phase, monitors chamber conditions in real time and archives a full cycle report.",
    techFeatures: [
      "AISI 316L sterilization chamber",
      "Torque-controlled dual-shaft shredder",
      "PLC control with 10\" colour touchscreen",
      "Automatic self-locking safety door",
      "Real-time temperature and pressure validation",
      "USB / network cycle-data export",
    ],
    specs: [
      ["Chamber volume", "Configurable 120 – 400 L"],
      ["Sterilization standard", "STAATT Level III"],
      ["Operating temperature", "134 °C"],
      ["Volume reduction", "Up to 80%"],
      ["Power supply", "400 V / 3-phase / 50 Hz"],
      ["Construction", "AISI 316L stainless steel"],
    ],
    options: [
      "Automated loading lift for wheeled bins",
      "Extended data-integrity and audit module",
      "Odour-management and air-treatment package",
      "Remote diagnostics and predictive maintenance",
    ],
    related: ["waste-shredder-unit", "large-steam-sterilizer", "steam-generator"],
  },
  {
    slug: "waste-shredder-unit",
    name: "STERILTRON Industrial Waste Shredder",
    category: "Steam Sterilizers",
    image: IMG.prodShredder,
    tagline: "Heavy-duty mechanical volume reduction for treated waste streams.",
    intro: "A rugged dual-shaft shredder engineered to render sterilized waste unrecognisable while maximising volume and weight reduction for economical downstream disposal.",
    overview: "The STERILTRON shredder pairs with our sterilization systems to complete the treatment line. Its torque-controlled cutting mechanism handles mixed clinical waste — including sharps containers and rigid plastics — reducing them to a uniform, unrecognisable fraction. Robust construction and automated jam-reversal ensure continuous, low-maintenance operation.",
    benefits: [
      "Maximises volume reduction to cut disposal costs",
      "Renders waste unrecognisable for confidentiality and safety",
      "Automated jam detection and reverse cycle",
      "Low-maintenance hardened cutting tools",
    ],
    applications: [
      "Post-sterilization volume reduction",
      "Regional treatment facilities",
      "Pharmaceutical destruction lines",
      "Confidential material destruction",
    ],
    technology: "Two counter-rotating shafts fitted with hardened cutting discs are driven by a torque-monitored geared motor. The controller continuously reads load current and automatically reverses to clear obstructions, protecting the drivetrain and sustaining throughput.",
    techFeatures: [
      "Dual-shaft hardened-steel cutters",
      "Torque-monitored geared drive",
      "Automatic jam-reversal logic",
      "Sealed, hygienic stainless enclosure",
      "Interlocked loading hopper",
      "Quick-access tooling for service",
    ],
    specs: [
      ["Throughput", "Up to 250 kg/h"],
      ["Cutter material", "Hardened tool steel"],
      ["Drive", "Torque-controlled geared motor"],
      ["Enclosure", "AISI 304 / 316L stainless steel"],
      ["Power supply", "400 V / 3-phase / 50 Hz"],
      ["Control", "PLC with safety interlocks"],
    ],
    options: [
      "Interchangeable cutter configurations",
      "Integrated weighing system",
      "Dust and aerosol extraction",
      "Custom hopper geometry",
    ],
    related: ["iss-integrated-sterilizer-shredder", "large-steam-sterilizer"],
  },
  {
    slug: "large-steam-sterilizer",
    name: "STERILTRON Large Steam Sterilizer",
    category: "Steam Sterilizers",
    image: IMG.prodLargeAutoclave,
    tagline: "High-capacity double-door autoclave for hospitals and CSSD departments.",
    intro: "A large-chamber pre-vacuum autoclave engineered for central sterile services, delivering validated, high-throughput sterilization of instruments, textiles and porous loads.",
    overview: "Built for central sterile supply departments, the large steam sterilizer offers a spacious AISI 316L chamber and pass-through double-door configuration that separates the non-sterile and sterile sides of a workflow. Fractionated pre-vacuum cycles ensure complete steam penetration of wrapped instrument sets and porous loads.",
    benefits: [
      "High daily throughput for busy CSSD operations",
      "Double-door barrier between clean and sterile zones",
      "Repeatable, fully documented validated cycles",
      "Energy and water optimisation as standard",
    ],
    applications: [
      "Hospital central sterile services (CSSD)",
      "Surgical instrument reprocessing",
      "Textile and porous-load sterilization",
      "Laboratory glassware and media",
    ],
    technology: "Fractionated pre-vacuum pulses evacuate air from the chamber and load before saturated steam is admitted, guaranteeing penetration into lumens and packs. The control system records temperature, pressure and time throughout for EN 285 compliant validation.",
    techFeatures: [
      "Pass-through double-door design",
      "Fractionated pre-vacuum cycle",
      "AISI 316L welded pressure vessel",
      "Independent process-monitoring channel",
      "Steam-saving jacket insulation",
      "Barrier-side status indication",
    ],
    specs: [
      ["Chamber volume", "300 – 900 L"],
      ["Standard", "EN 285"],
      ["Operating temperature", "121 – 134 °C"],
      ["Door type", "Automatic double-door"],
      ["Vessel material", "AISI 316L"],
      ["Supply", "Steam / electric / water"],
    ],
    options: [
      "Integrated clean-steam generator",
      "Loading trolley and transfer carriage",
      "Validation and traceability software suite",
      "Heat-recovery package",
    ],
    related: ["medium-steam-sterilizer", "steam-generator", "iss-integrated-sterilizer-shredder"],
  },
  {
    slug: "medium-steam-sterilizer",
    name: "STERILTRON Medium Steam Sterilizer",
    category: "Steam Sterilizers",
    image: IMG.prodMediumAutoclave,
    tagline: "Versatile free-standing autoclave for clinics, dental and veterinary use.",
    intro: "A balanced-capacity vertical sterilizer that brings hospital-grade cycle control to clinics, dental practices and veterinary facilities.",
    overview: "The medium steam sterilizer delivers dependable, validated sterilization in a compact free-standing footprint. With a range of programmable cycles for wrapped and unwrapped instruments, it suits practices that require assured infection control without the scale of a hospital CSSD.",
    benefits: [
      "Hospital-grade control in a compact footprint",
      "Fast cycle times for high patient turnover",
      "Simple, guided touchscreen operation",
      "Full cycle documentation for compliance",
    ],
    applications: [
      "Dental and orthodontic clinics",
      "Veterinary practices",
      "Outpatient and day-surgery clinics",
      "Research and teaching laboratories",
    ],
    technology: "A programmable controller manages gravity and vacuum-assisted cycles, adapting parameters to the selected load type. Integrated steam generation removes the need for an external supply, simplifying installation.",
    techFeatures: [
      "Integrated electric steam generator",
      "Multiple validated cycle presets",
      "Colour touchscreen with cycle log",
      "AISI 316L chamber",
      "Automatic door lock and safety interlocks",
      "Built-in printer / data export",
    ],
    specs: [
      ["Chamber volume", "60 – 150 L"],
      ["Standard", "EN 13060"],
      ["Operating temperature", "121 – 134 °C"],
      ["Cycles", "Wrapped / unwrapped / porous"],
      ["Vessel material", "AISI 316L"],
      ["Power supply", "400 V / 3-phase / 50 Hz"],
    ],
    options: [
      "Barcode load-tracking",
      "Water-treatment cartridge",
      "Instrument baskets and trays",
      "Network connectivity module",
    ],
    related: ["large-steam-sterilizer", "tabletop-autoclave", "steam-generator"],
  },
  {
    slug: "tabletop-autoclave",
    name: "STERILTRON Tabletop Class B Autoclave",
    category: "Steam Sterilizers",
    image: IMG.prodSmallAutoclave,
    tagline: "Compact Class B benchtop sterilizer for small practices.",
    intro: "A precision Class B benchtop autoclave that delivers fractionated-vacuum sterilization for the most demanding small-practice loads.",
    overview: "The tabletop autoclave brings full Class B performance to a benchtop format. Its fractionated pre- and post-vacuum phases sterilize hollow, wrapped and porous instruments alike, making it ideal for dental surgeries, aesthetic clinics and small laboratories where space is limited but assurance is not optional.",
    benefits: [
      "Full Class B performance in a benchtop unit",
      "Handles hollow, wrapped and porous loads",
      "Rapid warm-up and short cycle times",
      "Intuitive operation with automatic logging",
    ],
    applications: [
      "Dental and aesthetic clinics",
      "Small medical practices",
      "Tattoo and podiatry studios",
      "Compact laboratories",
    ],
    technology: "The Class B cycle performs multiple vacuum pulses before and after sterilization to ensure air removal and effective drying, verified by an independent sensor set and recorded for every run.",
    techFeatures: [
      "Class B fractionated vacuum cycle",
      "Independent process verification",
      "Automatic drying phase",
      "Compact stainless chamber",
      "USB cycle-data logging",
      "Water-quality monitoring",
    ],
    specs: [
      ["Chamber volume", "18 – 28 L"],
      ["Standard", "EN 13060 Class B"],
      ["Operating temperature", "121 – 134 °C"],
      ["Footprint", "Benchtop"],
      ["Vessel material", "AISI 316L"],
      ["Power supply", "230 V / 1-phase / 50 Hz"],
    ],
    options: [
      "External water-supply kit",
      "Additional instrument trays",
      "Thermal printer",
      "Traceability software licence",
    ],
    related: ["medium-steam-sterilizer", "large-steam-sterilizer"],
  },
  {
    slug: "steam-generator",
    name: "STERILTRON Clean Steam Generator",
    category: "Steam Sterilizers",
    image: IMG.prodSteamGen,
    tagline: "Consistent clean-steam supply engineered for sterilization duty.",
    intro: "An electric clean-steam generator that supplies high-quality, contaminant-free steam to sterilizers and process equipment on demand.",
    overview: "Reliable sterilization begins with reliable steam. The STERILTRON clean steam generator produces consistent, high-purity steam sized to the connected load, with fast response and redundant safety controls. It is the dependable utility backbone behind every STERILTRON sterilization line.",
    benefits: [
      "Consistent clean-steam quality protects the process",
      "Rapid response to fluctuating demand",
      "Compact skid-mounted installation",
      "Redundant safety and pressure controls",
    ],
    applications: [
      "Autoclave and CSSD steam supply",
      "Pharmaceutical clean-steam duty",
      "Laboratory process steam",
      "Humidification and utility support",
    ],
    technology: "Electric immersion heating elements convert treated feed-water into pure steam within a corrosion-resistant vessel. Modulating control matches output precisely to demand, while multi-level safety instrumentation protects the system continuously.",
    techFeatures: [
      "Corrosion-resistant pressure vessel",
      "Modulating output control",
      "Treated feed-water inlet",
      "Multi-level safety instrumentation",
      "Skid-mounted, pre-piped assembly",
      "Remote monitoring interface",
    ],
    specs: [
      ["Output", "50 – 500 kg/h"],
      ["Steam pressure", "Up to 10 bar"],
      ["Heating", "Electric immersion"],
      ["Vessel material", "Stainless steel"],
      ["Control", "PLC with modulation"],
      ["Mounting", "Skid-mounted"],
    ],
    options: [
      "Feed-water treatment package",
      "Redundant twin-generator layout",
      "Heat-recovery economiser",
      "Building-management integration",
    ],
    related: ["large-steam-sterilizer", "iss-integrated-sterilizer-shredder"],
  },
];

export { PRODUCTS, DOOR_TYPES } from "./products";

export const PRODUCT_CATEGORIES = [
  "Steam Sterilizers",
  "Plasma Sterilizers",
  "Washer and Disinfectors",
];

// Ordered product categories driving the Products page + Products dropdown menu.
// kind: "models" (door-type grouped), "consumables" (simple grid), "coming" (placeholder)
export const PRODUCT_CATEGORY_DEFS = [
  { name: "Medical Waste Sterilizers", navLabel: "Medical Waste Sterilizers", slug: "medical-waste-sterilizers", kind: "models" },
  { name: "Steam Sterilizers", navLabel: "Steam Sterilizers", slug: "steam-sterilizers", kind: "models" },
  { name: "Plasma Sterilizers", navLabel: "Plasma Sterilizers", slug: "plasma-sterilizers", kind: "models" },
  { name: "Washer and Disinfectors", navLabel: "Washer Disinfectors", slug: "washer-and-disinfectors", kind: "models" },
  { name: "Auxiliary Equipment", navLabel: "Auxiliary Equipment", slug: "auxiliary-equipment", kind: "coming" },
  { name: "Consumables", navLabel: "Consumables", slug: "consumables", kind: "consumables" },
];

// Consumable products — add new items to this list as they become available.
export const CONSUMABLES = [
  { slug: "buckets", name: "Buckets", description: "Rigid clinical waste collection buckets with secure lids for the safe containment of sharps and infectious waste.", image: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/7bb032cdc56877a29c2fa2a12f9569185176e7f4b1da7b5f7e2747f7943e61d7.jpeg" },
  { slug: "bags", name: "Bags", description: "Autoclavable biohazard waste bags for the collection and treatment of infectious healthcare waste.", image: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/9e2973f144c94e1d9fc969d7cfb53d9d67b0b61078a54d51831da7c35d87ef55.jpeg" },
  { slug: "h2o2-cartridges", name: "H\u2082O\u2082 Cartridges", description: "Hydrogen peroxide sterilant cartridges engineered for STERILTRON low-temperature plasma sterilizers.", image: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/77116e4e884e968f5e1353568c916ab6ed550bccde4852cc2b8c1cacb6d3eb3e.jpeg" },
];

export const SOLUTION_SECTORS = [
  { title: "Hospitals", text: "Turnkey on-site treatment and CSSD sterilization scaled to the throughput of large hospital campuses." },
  { title: "Medical Facilities", text: "Compact, validated systems for clinics, diagnostic centres and specialist medical facilities." },
  { title: "Healthcare Networks", text: "Standardised, centrally-monitored equipment fleets for multi-site healthcare providers." },
  { title: "Waste Management Facilities", text: "High-capacity treatment lines for regional operators handling aggregated clinical waste." },
  { title: "Industrial Facilities", text: "Custom decontamination and process systems for pharmaceutical and industrial plants." },
  { title: "Public Sector Projects", text: "Reliable, auditable infrastructure for government and municipal healthcare programmes." },
  { title: "International Turnkey Projects", text: "Complete design, delivery, installation and validation for projects anywhere in the world." },
];

export const PROJECTS = [
  { title: "Regional Hospital Waste Facility", region: "Central Europe", category: "Medical Waste Treatment", image: IMG.projectWaste, text: "A centralised on-site treatment line serving a 900-bed teaching hospital, replacing external hauling of untreated waste." },
  { title: "University Hospital CSSD Upgrade", region: "Western Europe", category: "Sterilization Systems", image: IMG.projectHospital, text: "Modernisation of a central sterile services department with double-door sterilizers and full traceability software." },
  { title: "Pharmaceutical Decontamination Line", region: "Middle East", category: "Industrial Solutions", image: IMG.projectIndustrial, text: "A custom effluent and biosafety decontamination system integrated into an existing manufacturing plant." },
  { title: "National Healthcare Network Rollout", region: "South-East Asia", category: "Integrated Waste Processing", image: IMG.projectWaste, text: "Standardised integrated sterilizer-shredder units deployed across a network of district hospitals." },
  { title: "Metropolitan Clinic Programme", region: "Northern Europe", category: "Sterilization Systems", image: IMG.projectHospital, text: "Fleet of medium and benchtop sterilizers commissioned across an urban outpatient clinic programme." },
  { title: "Regional Treatment Hub", region: "Africa", category: "Medical Waste Treatment", image: IMG.projectIndustrial, text: "A high-capacity regional facility processing aggregated clinical waste for surrounding healthcare providers." },
];

export const NEWS = [
  {
    slug: "steriltron-expands-international-operations",
    title: "STERILTRON expands its international operations",
    date: "May 2026",
    category: "Company",
    author: "STERILTRON Communications",
    readTime: "3 min read",
    image: IMG.aboutFacility,
    excerpt: "We continue to grow our global engineering and service footprint to support customers on more continents than ever before.",
    body: [
      "STERILTRON has entered a new phase of international growth, extending its engineering, commissioning and after-sales service capabilities to support a rapidly expanding base of healthcare and industrial customers.",
      "From our headquarters in Rétság, Hungary, our teams now coordinate turnkey projects across Europe, the Middle East, Africa and South-East Asia. Local service partnerships ensure that customers receive the same standard of technical support wherever their facilities operate.",
      "\"Reliability doesn't stop at delivery,\" said a member of our engineering leadership. \"When a hospital or treatment facility depends on our systems every single day, they need a partner who is present for the full lifecycle of the equipment — from specification through decades of operation.\"",
      "The expansion includes additional field service engineers, an enhanced remote diagnostics platform and a growing catalogue of spare parts held in regional stock, reducing response times for maintenance and upgrades.",
      "STERILTRON will continue to invest in the people and infrastructure required to deliver dependable medical waste treatment and sterilization technology to more customers, in more markets, without compromising on engineering quality.",
    ],
  },
  {
    slug: "next-generation-iss-platform",
    title: "Introducing the next-generation ISS platform",
    date: "April 2026",
    category: "Product",
    author: "Product Engineering Team",
    readTime: "4 min read",
    image: IMG.prodIss,
    excerpt: "Our latest integrated sterilizer-shredder brings enhanced data integrity and lower energy consumption to on-site waste treatment.",
    body: [
      "The next generation of the STERILTRON ISS integrated sterilizer and shredder has been engineered around two priorities that matter most to modern healthcare facilities: verifiable data integrity and reduced energy consumption.",
      "A redesigned control system now records every phase of each treatment cycle with tamper-evident logging, giving facilities a complete, audit-ready trail for every batch of waste processed. Cycle data can be exported to network storage or integrated directly with hospital information systems.",
      "On the mechanical side, an optimised steam circuit and improved chamber insulation reduce the energy required per cycle, while a torque-controlled shredder sustains throughput even with demanding mixed loads.",
      "The platform retains the compact, single-enclosure footprint that makes the ISS suitable for constrained utility rooms, while offering new optional modules for automated bin loading and odour management.",
      "The next-generation ISS reflects our conviction that on-site treatment should be safer, more transparent and more sustainable — without adding complexity for the operators who rely on it.",
    ],
  },
  {
    slug: "sustainability-in-medical-waste",
    title: "Rethinking sustainability in medical waste",
    date: "March 2026",
    category: "Insight",
    author: "STERILTRON Insights",
    readTime: "5 min read",
    image: IMG.sustainability,
    excerpt: "How on-site treatment reduces transport emissions and improves the environmental profile of healthcare facilities.",
    body: [
      "Medical waste has an environmental footprint that extends far beyond the point of disposal. Traditionally, infectious waste is collected, stored and transported — often over long distances — to centralised treatment sites, generating emissions and handling risk at every stage.",
      "On-site treatment fundamentally changes this equation. By neutralising the biological hazard where the waste is generated, facilities eliminate the need to haul untreated infectious material off-site, cutting transport emissions and reducing the chain of custody that comes with it.",
      "Volume reduction compounds the benefit. When treated waste is shredded and compacted, its weight and volume fall dramatically, meaning fewer collections and less downstream processing for the fraction that does leave the site.",
      "Energy and water recovery options reduce the resources consumed by each cycle, and validated processes ensure that this efficiency never comes at the cost of safety or compliance.",
      "Sustainability in medical waste is not a single feature — it is the sum of many engineering decisions. At STERILTRON, we treat each of those decisions as an opportunity to lower the environmental impact of the facilities we serve.",
    ],
  },
  {
    slug: "engineering-for-reliability",
    title: "Engineering for reliability: our design philosophy",
    date: "February 2026",
    category: "Engineering",
    author: "STERILTRON Engineering",
    readTime: "4 min read",
    image: IMG.engineeringTeam,
    excerpt: "A look inside the principles that guide every STERILTRON system, from material selection to lifecycle support.",
    body: [
      "Equipment that treats hazardous waste cannot afford to fail. That simple truth shapes every decision our engineers make, from the first concept sketch to the final factory acceptance test.",
      "It begins with materials. We build our chambers and pressure vessels from AISI 316L stainless steel, selected for its corrosion resistance and longevity under repeated thermal cycling. Generous safety margins are designed in from the outset, not added as an afterthought.",
      "Architecture matters just as much. We favour serviceable designs with accessible components, so that maintenance is fast and downtime is minimal. Redundant safety instrumentation protects both the process and the people who operate it.",
      "Finally, reliability is verified, not assumed. Every system undergoes rigorous testing before it leaves our facility, and validated cycles document performance throughout the equipment's operational life.",
      "This philosophy is why customers trust STERILTRON systems to run dependably for decades — and why we continue to refine it with every project we deliver.",
    ],
  },
];

const BIMG = {
  waste_tech: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/e3477a6236116157b59dfd3a5e5dc0053e7b53434b39c9e3a20f726be6e61b66.jpeg",
  steam: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/317a70ac21c1553f3bfaa90f29238eb0159664229ad80434ca4a1caceec8cbdf.jpeg",
  onsite: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/b6cea0f22a9d469ee8ff7315990b313f077dcf84e9813395262bd2e80b3ec73e.jpeg",
  integrated: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/3bc42acf1ec642a736a7ee6beec1ff6f0df47eb50a9544399c89e59de0fafc73.jpeg",
  automation: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/b40371771a4865a95ac298c9d6a0ebe20329ee1edd323f588ae2270d719df7be.jpeg",
  sustainability: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/5666af3c7ea168a90e1557fd2e57b6353fc3b79a49ae2c444baab8e6c038e782.jpeg",
  choosing: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/9c5164f380eedeae920e095fa2cc7e415037ba9c161acb1aab7af1967d490115.jpeg",
  autoclave: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/c65a74e41b87f3425663f0bdd3ef7e747380fc0f160cf9e7a1ddc2219e65758a.jpeg",
};

export const HOME_VIDEO_BG = "/assets/green/video-bg.jpg";

export const BLOG_CATEGORIES = ["All", "Waste Treatment", "Sterilization", "Operations", "Technology", "Automation", "Sustainability", "Guide"];

export const BLOG_POSTS = [
  {
    slug: "medical-waste-treatment-technologies",
    title: "Medical Waste Treatment: Technologies for Safer Healthcare Facilities",
    category: "Waste Treatment",
    date: "June 2026",
    readTime: "6 min read",
    image: BIMG.waste_tech,
    excerpt: "How modern treatment technologies neutralise infectious waste at the source and protect healthcare environments.",
    related: ["on-site-medical-waste-treatment-advantages", "integrated-sterilization-and-shredding"],
    body: [
      { type: "p", text: "Healthcare facilities generate a continuous stream of infectious and hazardous waste that must be neutralised before it can safely leave the site. The technologies used to achieve this have advanced significantly, moving from centralised incineration toward on-site, validated thermal treatment that is both safer and more sustainable." },
      { type: "h", text: "The shift toward on-site treatment" },
      { type: "p", text: "Treating waste where it is generated removes the risk associated with storing and transporting untreated infectious material. It gives facilities direct control over their waste stream and produces a complete, auditable record of every treated batch — a level of accountability that external hauling cannot match." },
      { type: "h", text: "Validated thermal sterilization" },
      { type: "p", text: "At the core of modern treatment is moist-heat sterilization. Saturated steam is applied at a controlled temperature and pressure long enough to inactivate all microbial life, meeting internationally recognised standards. Because the process is monitored and documented in real time, operators can be confident that each cycle achieved the required conditions." },
      { type: "img", src: BIMG.integrated, alt: "Integrated medical waste treatment technology" },
      { type: "h", text: "Volume reduction and traceability" },
      { type: "p", text: "Combining sterilization with mechanical shredding reduces the volume and weight of treated waste dramatically, lowering downstream disposal costs and rendering the output unrecognisable. Coupled with digital cycle logging, the result is a treatment line that is efficient, safe and fully traceable." },
      { type: "p", text: "For healthcare facilities weighing their options, the direction is clear: validated, on-site technology offers the safest and most controllable path to responsible medical waste management." },
    ],
  },
  {
    slug: "steam-sterilization-how-it-works",
    title: "Steam Sterilization: How the Technology Works",
    category: "Sterilization",
    date: "June 2026",
    readTime: "5 min read",
    image: BIMG.steam,
    excerpt: "A clear look at the principles behind saturated-steam sterilization and why it remains the healthcare standard.",
    related: ["understanding-autoclave-technology", "medical-waste-treatment-technologies"],
    body: [
      { type: "p", text: "Steam sterilization is the most widely trusted method for eliminating microbial life from medical instruments and materials. Its reliability comes from a simple but powerful principle: saturated steam under pressure transfers heat far more effectively than dry air." },
      { type: "h", text: "Why saturated steam" },
      { type: "p", text: "When steam condenses on a cooler surface it releases a large amount of latent heat and rapidly raises the temperature of the item. This efficient energy transfer, sustained for a validated exposure time, denatures the proteins essential to microbial survival — achieving sterilization." },
      { type: "h", text: "The importance of air removal" },
      { type: "p", text: "Air is the enemy of effective sterilization because it prevents steam from reaching every surface. Modern sterilizers use fractionated pre-vacuum pulses to evacuate air from both the chamber and the load, ensuring steam penetrates lumens, wrapped instruments and porous materials completely." },
      { type: "img", src: BIMG.autoclave, alt: "Autoclave chamber with sterilized instruments" },
      { type: "h", text: "Validation and documentation" },
      { type: "p", text: "Every phase — conditioning, exposure and drying — is monitored for temperature, pressure and time. A documented cycle record provides the assurance that healthcare and laboratory environments require, and forms part of the audit trail for regulatory compliance." },
    ],
  },
  {
    slug: "on-site-medical-waste-treatment-advantages",
    title: "On-Site Medical Waste Treatment: Key Operational Advantages",
    category: "Operations",
    date: "May 2026",
    readTime: "5 min read",
    image: BIMG.onsite,
    excerpt: "The logistical, safety and operational benefits of treating clinical waste within the facility.",
    related: ["medical-waste-treatment-technologies", "sustainable-healthcare-waste-management"],
    body: [
      { type: "p", text: "Choosing to treat medical waste on-site rather than shipping it to a centralised facility changes the operational profile of a healthcare provider in several important ways." },
      { type: "h", text: "Reduced logistics and handling" },
      { type: "p", text: "On-site treatment eliminates the need to schedule, store and transport untreated infectious waste. This reduces handling steps, lowers the risk of spills or exposure, and removes dependence on third-party collection timetables." },
      { type: "h", text: "Improved safety and control" },
      { type: "p", text: "When waste is neutralised at the point of generation, the window in which hazardous material poses a risk is minimised. Facilities gain direct oversight of the entire process and can respond immediately to changes in waste volume." },
      { type: "h", text: "Cost predictability" },
      { type: "p", text: "By reducing volume through integrated shredding and cutting external collection frequency, facilities gain greater control over disposal costs and can plan their waste budgets with more confidence." },
    ],
  },
  {
    slug: "integrated-sterilization-and-shredding",
    title: "Integrated Sterilization and Shredding Technologies",
    category: "Technology",
    date: "May 2026",
    readTime: "6 min read",
    image: BIMG.integrated,
    excerpt: "How combining sterilization and shredding in one enclosure creates a compact, self-contained treatment line.",
    related: ["medical-waste-treatment-technologies", "automation-in-modern-waste-treatment"],
    body: [
      { type: "p", text: "Integrated systems bring two essential steps — sterilization and shredding — together within a single automated sequence, producing a decontaminated and unrecognisable output in one pass." },
      { type: "h", text: "One chamber, one cycle" },
      { type: "p", text: "In an integrated unit, waste is loaded once. Saturated steam sterilizes the load, and a torque-controlled shredder then renders it unrecognisable — all without a separate transfer step. This minimises operator handling and the associated contamination risk." },
      { type: "h", text: "A smaller footprint" },
      { type: "p", text: "Because both functions share one enclosure, the integrated approach occupies far less space than a multi-machine layout, making it ideal for facilities with constrained utility rooms." },
      { type: "img", src: BIMG.automation, alt: "Integrated system control interface" },
      { type: "h", text: "Consistent, documented results" },
      { type: "p", text: "A programmable controller governs every phase and archives a complete cycle report, delivering repeatable performance and full traceability from a single compact system." },
    ],
  },
  {
    slug: "automation-in-modern-waste-treatment",
    title: "The Role of Automation in Modern Waste Treatment Systems",
    category: "Automation",
    date: "April 2026",
    readTime: "5 min read",
    image: BIMG.automation,
    excerpt: "Why programmable control and process automation are central to safe, repeatable treatment.",
    related: ["integrated-sterilization-and-shredding", "choosing-the-right-medical-waste-treatment-system"],
    body: [
      { type: "p", text: "Automation has transformed medical waste treatment from a manually supervised task into a precise, repeatable and fully documented process." },
      { type: "h", text: "Programmable logic control" },
      { type: "p", text: "A PLC governs each phase of the treatment cycle, holding temperature, pressure and time within tight tolerances. This removes operator guesswork and guarantees that every batch is processed to the same validated standard." },
      { type: "h", text: "Real-time monitoring" },
      { type: "p", text: "Sensors continuously report chamber conditions, allowing the system to detect deviations and respond automatically. Operators receive clear status information through an intuitive touchscreen interface." },
      { type: "h", text: "Data integrity and remote support" },
      { type: "p", text: "Automated systems archive tamper-evident cycle records and can connect to remote diagnostics platforms, enabling predictive maintenance and reducing unplanned downtime." },
    ],
  },
  {
    slug: "sustainable-healthcare-waste-management",
    title: "Sustainable Approaches to Healthcare Waste Management",
    category: "Sustainability",
    date: "April 2026",
    readTime: "5 min read",
    image: BIMG.sustainability,
    excerpt: "Practical ways healthcare facilities can lower the environmental footprint of their waste streams.",
    related: ["on-site-medical-waste-treatment-advantages", "medical-waste-treatment-technologies"],
    body: [
      { type: "p", text: "Sustainability in healthcare extends beyond clinical care to how facilities manage the waste they produce. Thoughtful choices in treatment technology can meaningfully reduce environmental impact." },
      { type: "h", text: "Cutting transport emissions" },
      { type: "p", text: "On-site treatment removes the need to haul untreated waste to distant facilities, eliminating a significant source of transport emissions and road handling." },
      { type: "h", text: "Reducing volume and energy" },
      { type: "p", text: "Volume reduction means fewer collections and less downstream processing, while energy- and water-recovery options lower the resources consumed by each treatment cycle." },
      { type: "h", text: "A measurable improvement" },
      { type: "p", text: "Together, these measures allow facilities to manage hazardous waste more responsibly while making genuine, measurable progress toward their environmental goals." },
    ],
  },
  {
    slug: "choosing-the-right-medical-waste-treatment-system",
    title: "Choosing the Right Medical Waste Treatment System",
    category: "Guide",
    date: "March 2026",
    readTime: "7 min read",
    image: BIMG.choosing,
    excerpt: "A practical guide to matching treatment technology to your facility's capacity and requirements.",
    related: ["automation-in-modern-waste-treatment", "integrated-sterilization-and-shredding"],
    body: [
      { type: "p", text: "Selecting a medical waste treatment system is a decision that affects safety, cost and operations for years. A structured evaluation helps ensure the technology fits the facility, not the other way around." },
      { type: "h", text: "Assess your waste volume" },
      { type: "p", text: "Start with an honest picture of daily and peak waste generation. The right capacity avoids both under-provisioning, which creates bottlenecks, and over-provisioning, which wastes capital and energy." },
      { type: "h", text: "Consider space and utilities" },
      { type: "p", text: "Available floor space, steam and power supply all shape the options. Integrated systems suit constrained rooms, while larger facilities may benefit from separate high-capacity lines." },
      { type: "h", text: "Prioritise validation and support" },
      { type: "p", text: "Choose systems that document every cycle and are backed by dependable engineering support. Long-term reliability and service availability are as important as the initial specification." },
    ],
  },
  {
    slug: "understanding-autoclave-technology",
    title: "Understanding Autoclave Technology",
    category: "Sterilization",
    date: "March 2026",
    readTime: "5 min read",
    image: BIMG.autoclave,
    excerpt: "The fundamentals of industrial and medical autoclaves and the loads they are designed to sterilize.",
    related: ["steam-sterilization-how-it-works", "choosing-the-right-medical-waste-treatment-system"],
    body: [
      { type: "p", text: "An autoclave is a pressure vessel designed to sterilize equipment and materials using saturated steam. From compact benchtop units to large hospital chambers, the underlying technology is remarkably consistent." },
      { type: "h", text: "Chamber and cycle types" },
      { type: "p", text: "Autoclaves use gravity, pre-vacuum or Class B cycles depending on the load. Pre-vacuum and Class B cycles remove air actively, making them suitable for hollow, wrapped and porous items." },
      { type: "h", text: "Materials and construction" },
      { type: "p", text: "Quality autoclaves are built from AISI 316L stainless steel for corrosion resistance and longevity under repeated thermal cycling, with precision-welded pressure vessels for safety." },
      { type: "h", text: "Choosing the right size" },
      { type: "p", text: "From dental clinics to central sterile services departments, matching chamber capacity and cycle type to the intended loads ensures both efficiency and consistently validated results." },
    ],
  },
];

export const VIDEO_CATEGORIES = [
  "All",
  "Medical Waste Treatment",
  "Integrated Sterilization & Shredding",
  "Medical Steam Sterilizers",
  "Industrial Solutions",
  "Technology & Process Animations",
  "STERILTRON Corporate",
];

// embedUrl left empty as placeholder — set a YouTube/Vimeo embed URL later to activate playback.
export const VIDEOS = [
  { id: "v1", title: "Medical Waste Treatment Process", description: "A walkthrough of how STERILTRON systems neutralise infectious waste on-site.", category: "Medical Waste Treatment", thumbnail: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/8b900b44a8f238d2ff3ba309caf77c82a1318e4f8943ccc012b35d1925a4ab4f.jpeg", embedUrl: "", demo: true },
  { id: "v2", title: "Integrated Sterilization & Shredding Technology", description: "See how sterilization and shredding combine within a single automated cycle.", category: "Integrated Sterilization & Shredding", thumbnail: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/03a821bc887e153e9c4d54648b723b71c58c0d3e35ba1ef518280e29503963a6.jpeg", embedUrl: "", demo: true },
  { id: "v3", title: "How Steam Sterilization Works", description: "The principles of saturated-steam sterilization explained.", category: "Medical Steam Sterilizers", thumbnail: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/b855e19de4b8acffe6828a60baa95edafb54404cac111ba918b148c06fbcc271.jpeg", embedUrl: "", demo: true },
  { id: "v4", title: "Medical Waste Processing — Process Animation", description: "An animated overview of the complete treatment process flow.", category: "Technology & Process Animations", thumbnail: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/e11ec0218fb18305f2c16bdf2f1266999cbd3355c525045610b4971671d95e6c.jpeg", embedUrl: "", demo: true },
  { id: "v5", title: "STERILTRON System Overview", description: "A tour of a complete STERILTRON medical waste treatment line.", category: "STERILTRON Corporate", thumbnail: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/d66220855526208d93fe37116fc06bb4de2c67514618a148974f8f086ab72053.jpeg", embedUrl: "", demo: true },
  { id: "v6", title: "Automated Waste Treatment Process", description: "How automation drives safe, repeatable treatment cycles.", category: "Technology & Process Animations", thumbnail: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/21d61e5514f9c5323fc00b05d65cfa9513ba06110cf9f112b2efd0ab9424ce53.jpeg", embedUrl: "", demo: true },
  { id: "v7", title: "Industrial Steam Sterilizer Overview", description: "A closer look at large-scale industrial steam sterilization.", category: "Industrial Solutions", thumbnail: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/77fca4e34985181a12b16606f79b2249b25ba87d1b31d2f16a3e3d8b1d17731b.jpeg", embedUrl: "", demo: true },
  { id: "v8", title: "Engineering & Manufacturing at STERILTRON", description: "Inside our engineering and manufacturing capabilities.", category: "STERILTRON Corporate", thumbnail: "https://static.prod-images.emergentagent.com/jobs/afbebc91-dbf9-4e9d-998a-dca47a60d5c1/images/1b66034142e6075006d1e02ed69c1f9f7b1964a8c42f553281b19a7c99de6046.jpeg", embedUrl: "", demo: true },
];

export const CONTACT = {
  email: "info@steriltron.com",
  address: "2651 Rétság, Pusztaszántói út 10.",
  city: "Hungary",
  phone: "+36 30 894 6964",
  phoneHref: "tel:+36308946964",
  mapQuery: "2651 Rétság, Pusztaszántói út 10., Hungary",
};

export const DEPARTMENTS = ["Sales", "Engineering", "Technical Support", "Service & Maintenance", "Partnerships", "General Enquiry"];
